// --------------------------------------------------------------
// Created On: 2026-11-02
// Author: Zachary Thomas
//
// Last Modified: 2026-11-03
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

export const TABLE_COMPONENT_TYPE = "TABLE";
export const GAUGE_COMPONENT_TYPE = "GAUGE";
export const GAUGE_TYPE_TANK_ROUND = "ROUND_TANK";
export const GAUGE_TYPE_TANK_SQUARE = "SQUARE_TANK";
export const GAUGE_TYPE_RADIAL = "RADIAL";
export const GAUGE_TYPE_SPEEDOMETER = "SPEEDOMETER";
